import * as actionTypes from '../actions/actionTypes'

const initialState = {
    termsConditions : '',
    privacyPolicy : ''
}

const gdprReducer = (state = initialState, actions) => {
    switch(actions.type){
        case actionTypes.GDPR_SUCCESS_PRIVACY_POLICY:
            return {
                ...state,
                privacyPolicy : actions.privacyPolicy
            }
        case actionTypes.GDPR_SUCCESS_TERMS_CONDITIONS:
            return {
                ...state,
                termsConditions : actions.termsConditions
            }
        default:
            return state
    }
}

export default gdprReducer



// WEBPACK FOOTER //
// ./src/store/reducers/gdprReducer.js